import React from "react";
import { LongTextLabel } from "@sscs/ui";
import { buildRlPurl, humanReadableBytes } from "@sscs/utils";
import { SoftwareInfo } from "Components";
import { UrlImportData, VersionSoftwareInfo } from "Types";

type OverviewProps = {
  urlImportData: UrlImportData;
  projectName: string;
  packageName: string;
  softwareInfo: VersionSoftwareInfo;
  predecessorVersion: string | undefined;
  fileSize: number | null;
  remainingAfterImport: number;
  showForce: boolean;
  showReplace: boolean;
};

const Overview = ({
  urlImportData,
  projectName,
  packageName,
  softwareInfo,
  predecessorVersion,
  fileSize,
  remainingAfterImport,
  showForce,
  showReplace,
}: OverviewProps): React.JSX.Element => {
  const isPurl = urlImportData.url.startsWith("pkg");
  let importUrl;

  if (!isPurl) {
    try {
      importUrl = new URL(urlImportData.url);
    } catch (_error) {
      if (!PRODUCTION) {
        // eslint-disable-next-line no-console
        console.log("Invalid import URL", urlImportData.url);
      }
    }
  }

  return (
    <SoftwareInfo.Overview
      softwareInfo={softwareInfo}
      isVersion
      predecessorVersion={predecessorVersion}
      showForce={showForce}
      showReplace={showReplace}
      title="Software information"
      leadingList={[
        {
          "Importing from": isPurl ? (
            <code>
              <LongTextLabel
                label={urlImportData.url}
                title={urlImportData.url}
              />
            </code>
          ) : (
            <LongTextLabel
              label={importUrl ? importUrl.host : urlImportData.url}
              title={urlImportData.url}
            />
          ),
          "Importing to": (
            <code>
              {buildRlPurl(projectName, packageName, softwareInfo.version)}
            </code>
          ),
          "Estimated file size": fileSize
            ? humanReadableBytes(fileSize)
            : "Unknown",
          ...(fileSize
            ? {
                "Remaining capacity after import":
                  humanReadableBytes(remainingAfterImport),
              }
            : {}),
        },
      ]}
    />
  );
};

export default Overview;
